type EnhancedLoggingScope = 'logging';

const consentMap = new Map<EnhancedLoggingScope, boolean>();

/** Called by useLoggerConsentSync whenever consent state changes. */
export function setLoggerConsent(granted: boolean): void {
  consentMap.set('logging', granted);
}

export function hasEnhancedLoggingConsent(): boolean {
  if (typeof window === 'undefined') return true; // always allow on server
  return consentMap.get('logging') ?? false; // deny by default until synced
}

/**
 * Wraps an enhancer so it only contributes data when enhanced-logging consent
 * is granted. Essential log data (message, level, stack) always flows — this
 * gates supplementary context such as user identity and tenant info.
 */
export function withConsentEnhancer(
  enhancer: () => Record<string, unknown>,
): () => Record<string, unknown> {
  return () => (hasEnhancedLoggingConsent() ? enhancer() : {});
}
